/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { PublicMonitorTemplateFilterNotificationRuleMonitorScopeConditionDto } from './PublicMonitorTemplateFilterNotificationRuleMonitorScopeConditionDto';
import type { PublicNotificationRuleMonitorScopeDto } from './PublicNotificationRuleMonitorScopeDto';
import type { PublicSeverityFilterNotificationRuleMonitorScopeConditionDto } from './PublicSeverityFilterNotificationRuleMonitorScopeConditionDto';
import type { PublicTagFilterNotificationRuleMonitorScopeConditionDto } from './PublicTagFilterNotificationRuleMonitorScopeConditionDto';

export type PublicFilteredNotificationRuleMonitorScopeDto = (PublicNotificationRuleMonitorScopeDto & {
    /**
     * List of the conditions defining monitor scope of the notification rule
     */
    conditions?: Array<(PublicMonitorTemplateFilterNotificationRuleMonitorScopeConditionDto | PublicSeverityFilterNotificationRuleMonitorScopeConditionDto | PublicTagFilterNotificationRuleMonitorScopeConditionDto)>;
    /**
     * Logical operator to use between conditions
     */
    filterLogicalOperator?: PublicFilteredNotificationRuleMonitorScopeDto.filterLogicalOperator;
} & {
    /**
     * List of the conditions defining monitor scope of the notification rule
     */
    conditions: Array<(PublicMonitorTemplateFilterNotificationRuleMonitorScopeConditionDto | PublicSeverityFilterNotificationRuleMonitorScopeConditionDto | PublicTagFilterNotificationRuleMonitorScopeConditionDto)>;
    /**
     * Logical operator to use between conditions
     */
    filterLogicalOperator: PublicFilteredNotificationRuleMonitorScopeDto.filterLogicalOperator;
});

export namespace PublicFilteredNotificationRuleMonitorScopeDto {

    /**
     * Logical operator to use between conditions
     */
    export enum filterLogicalOperator {
        AND = 'AND',
        OR = 'OR',
    }


}
